export default __webpack_public_path__ + "images/fec55decae354e7c874096be7b8be9cb-hinduism_small.webp";